<script setup lang="ts">
import { computed } from 'vue'
import { siteUrl } from '@/configs/urls'

const isMobile = computed(() => false)
</script>

<template>
  <div>
    <div class="absolute top-0 z-[99] w-full px-6 lg:px-24 bg-none border-b bg-[#F0F2F5] border-[#9999BF]">
      <Container>
        <div class="flex justify-between items-center h-[65px] lg:h-[105px]">
          <div class="flex items-center justify-between">
            <a :href="siteUrl('/')" class="ml-4 hidden lg:block">
              <img src="/img/header/Logo.svg" />
            </a>
            <NotFoundMobileMenu class="block lg:hidden" />
            <a href="/" class="mr-3 block lg:hidden">
              <img src="/img/header/Logo-mobile.svg" />
            </a>
            <a :href="siteUrl('/')" class="hidden lg:block mt-2 pb-1  px-3 text-[#71757A]"> خانه </a>
            <a :href="siteUrl('/terms')" class="hidden lg:block mt-2 pb-1 px-3 text-[#71757A]"> قوانین </a>
            <div
              class="relative group cursor-pointer hidden lg:flex items-center gap-2.5 text-[#71757A] font-normal text-base px-3 ms-1">
              <span>پشتیبانی</span>
              <img src="/img/header/arrow-square-down-gray.svg" class="group-hover:rotate-180" />
              <div class="absolute top-full pt-2 hidden group-hover:block w-full">
                <div class="text-[#2626BF] bg-white rounded-xl shadow-lg px-4 p-3 text-base z-50 w-max">
                  <a id="btn-telegram" href="https://t.me/+989101369884" class="flex items-center gap-1 mb-4">
                    <img src="/img/footer/telegram-2.svg" alt="telegram-icon" />
                    تلگرام
                  </a>
                  <a id="btn-whatsapp" href="https://wa.me/989101369884" class="flex items-center gap-1">
                    <img src="/img/footer/whatsapp2.svg" alt="whatsapp-icon" />
                    واتساپ
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-start items-center gap-6">
            <!-- <a :href="siteUrl('/terms')" class="hidden lg:block text-[#71757A] font-normal text-base">
              درباره پی‌جیب
            </a> -->
            <a :href="siteUrl('/blog/')" class="hidden lg:block text-[#71757A] font-normal text-base">
              وبلاگ
            </a>
            <router-link id="btn-login-or-register" to="/auth/login" :x-small="isMobile" :small="!isMobile"
              class="login-btn font-semibold border-[#2E2EE5] border-2 rounded-[48px] flex items-center justify-center text-sm md:text-base px-4 h-[33px] md:h-[46px] text-[#2E2EE5]">
              ورود یا ثبت نام
            </router-link>
          </div>
        </div>
      </Container>
    </div>
  </div>
</template>

<style>
.active-item {
  border-bottom: 4px solid #2e2ee5;
  color: #2e2ee5;
  font-weight: 600;
}
</style>
